import { Chip } from "@nt/ui/chip";
import { LifeBuoy, LogOut, UserRound } from "lucide-react";

import { SUPPORT_EMAIL } from "@/components/layout/partner-sidebar";
import { Button } from "@nt/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@nt/ui/dropdown-menu";
import { SidebarTrigger } from "@nt/ui/sidebar";
import type { Session } from "@/lib/queries";
import { signOut } from "@/lib/sign-out";

/**
 * The 56px top bar under 768px (admin's `AdminNavbar` pattern): the trigger
 * that opens the sidebar sheet, the mark, and the account menu. Hidden on
 * desktop, where the sidebar is always there.
 */
export function PartnerNavbar({ session }: { session: Session }) {
  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b border-border bg-background px-4 md:hidden">
      <SidebarTrigger className="-ml-1" />
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <img
          src="/nonresidentTaxIcon.svg"
          alt=""
          width={24}
          height={24}
          className="size-6 shrink-0 rounded-sm"
        />
        <span className="truncate text-sm font-semibold text-foreground">
          Partner portal
        </span>
        {session.state === "read_only" ? (
          <Chip tone="warning" size="sm">
            Read-only
          </Chip>
        ) : null}
      </div>
      <DropdownMenu>
        <DropdownMenuTrigger
          render={
            <Button variant="ghost" size="icon-sm" aria-label="Account" />
          }
        >
          <UserRound className="size-5" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-64">
          <DropdownMenuGroup>
            <DropdownMenuLabel>Signed in as {session.email}</DropdownMenuLabel>
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuItem render={<a href={`mailto:${SUPPORT_EMAIL}`} />}>
            <LifeBuoy className="size-4 text-muted-foreground" />
            Need help?
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => void signOut()}>
            <LogOut className="size-4 text-muted-foreground" />
            Sign out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  );
}
